const SIZE_INVENTORY = {
    customPixel1: [1, 1],
    customPixel3: [1, 3],
    customPixel2: [2, 2],
    skyscraper: [120, 600],
    wideSkyscraper: [160, 600],
    manchette: [184, 90],
    manchetteProg1: [184, 91],
    manchetteProg2: [184, 92],
    custom3001: [300, 1],
    custom30050: [300, 50],
    custom30051: [300, 51],
    oneThirdPage: [300, 100],
    oneThirdPageProg: [300, 101],
    oneThirdPageProg2: [300, 102],
    mediumRectangle: [300, 250],
    mediumRectangleProg: [300, 251],
    mediumRectangleProg2: [300, 252],
    mediumRectangleProg3: [300, 253],
    halfPage: [300, 600],
    mobileBanner: [320, 50],
    mobileBannerProg: [320, 51],
    largeMobileBanner: [320, 100],
    largeMobileBannerProg: [320, 101],
    masthead: [320, 150],
    mastheadProg: [320, 151],
    giantMasthead: [320, 200],
    giantMastheadProg: [320, 201],
    mobileVideo: [320, 240],
    mobileInterstitial: [320, 480],
    largeRectangle: [336, 280],
    customSquare600: [600, 600],
    customBanner1: [620, 90],
    customVideo: [640, 365],
    leaderboard: [728, 90],
    leaderboardProg: [728, 91],
    leaderboardProg2: [728, 92],
    wideBannerSmall: [940, 60],
    wideBannerSmallProg: [940, 61],
    wideBannerSmallProg2: [940, 62],
    wideBanner: [940, 90],
    wideBannerProg: [940, 91],
    wideBannerProg2: [940, 92],
    customRectangle1: [940, 530],
    customRectangle1Prog: [940, 531],
    largeLeaderboard: [970, 90],
    billboard: [970, 250],
    billboardProg: [970, 251],
    billboardProg2: [970, 252],
    skinProg: [1800, 1000],
    skin: [1920, 1080],
    skin2: [1920, 1081],
    fluid: 'fluid',
};

export { SIZE_INVENTORY };
